<template>
  <base-material-filter
    title="Търсене на потребители"
    :hasFilters="hasActiveFilters"
    v-on:do-filter="doFilter"
    v-on:remove-filter="clearFilters" 
  >
    <v-row @keypress.enter="doFilter" class="mx-1">
      <v-col lg="3" md="4" cols="12">
        <v-text-field 
          label="Име"
          v-model="filters.firstName"
          clearable
          autocomplete="off"
        />
      </v-col>
      <v-col lg="3" md="4" cols="12">
        <v-text-field 
          label="Презиме"
          v-model="filters.middleName"
          clearable
          autocomplete="off"
        />
      </v-col>
      <v-col lg="3" md="4" cols="12">
        <v-text-field 
          label="Фамилия"
          v-model="filters.lastName"
          clearable
          autocomplete="off"
        />
      </v-col>
      <v-col lg="3" md="4" cols="12">
        <v-text-field 
          label="E-mail" 
          v-model="filters.email"
          clearable
          autocomplete="off"
        />
      </v-col>
      <v-col lg="3" md="4" cols="12">
        <v-text-field 
          label="Телефон" 
          v-model="filters.phone"
          clearable
          autocomplete="off"
        />
      </v-col>
      <v-col lg="3" md="4" cols="12">
        <base-select
          :items="properties.statuses"
          item-text="name"
          item-value="value"
          v-model="filters.status"
          label="Активност"
          clearable
          autocomplete="off"
        >
        </base-select>
      </v-col>
      <v-col lg="3" md="4" cols="12">
        <base-select
          :items="properties.access"
          item-text="name"
          item-value="value"
          v-model="filters.access"
          label="Права"
          clearable
          autocomplete="off"
        >
        </base-select>
      </v-col>
    </v-row>
  </base-material-filter>
</template>

<script>

import { isEmptyObject } from "@/utils";

const filtersModel = Object.freeze({
  firstName: '',
  middleName: '',
  lastName: '',
  email: '',
  phone: '',
  access: '',
  status: '',
});

export default {
  name: "usersFilter",
  data(){
    return {
      properties: {
        statuses: [
          {name: "Активен", value: 1},
          {name: "Неактивен", value: 0}
        ],
        access: [
          {name: "Администратор", value: 0},
          {name: "Потребител", value: 1}
        ]
      },
      filters: Object.assign({}, filtersModel),
      hasActiveFilters: false
    }
  },
  methods: {
    doFilter(){
      if(!isEmptyObject(this.filters)){
        this.filters.page = 1;
        this.hasActiveFilters = true;
        this.$emit("doFilter");
        delete this.filters.page;
      } else {
        if(this.hasActiveFilters === true)
          this.$emit("doFilter");
          
        this.hasActiveFilters = false;
      }
    },
    clearFilters(){
      this.filters = Object.assign({}, filtersModel);

      this.hasActiveFilters = false;

      this.$emit("doFilter", true);
    },
  }
}
</script>